var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnMenuAuthor = function SvgIcnMenuAuthor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19C23.5899 19 26.5 16.0899 26.5 12.5C26.5 8.91015 23.5899 6 20 6C16.4101 6 13.5 8.91015 13.5 12.5C13.5 16.0899 16.4101 19 20 19Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 33C7.5 28.0243 12.4302 24 18.5 24",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7053 32.0736L17.2718 35.6065C16.8937 35.9956 16.6273 36.4765 16.5 37L21.3753 33.2286C22.9015 33.8944 24.1206 34.1064 25.0549 34.1064C26.6964 34.1064 27.4584 33.4515 27.4584 33.4515C25.9303 32.6693 25.7125 31.2095 25.7125 31.2095C26.8829 31.6962 29.3209 32.27 29.3209 32.27C32.5587 30.1443 34.2508 25.5421 34.2508 25.5421C33.9156 25.6327 33.595 25.6705 33.2929 25.6705C31.7733 25.6705 30.7292 24.7133 30.7292 24.7133L34.9591 23.8072C36.3655 20.9688 36.5 16 36.5 16L23.6393 27.2517C22.1829 28.5259 21.1588 30.2089 20.7053 32.0736Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnMenuAuthor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_menu_author.4cc55e9d.svg";
export { ForwardRef as ReactComponent };